'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var th = {
  code: "th",
  week: {
    dow: 1,
    doy: 4
  },
  buttonText: {
    prev: "\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32",
    next: "\u0E16\u0E31\u0E14\u0E44\u0E1B",
    prevYear: "\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32",
    nextYear: "\u0E1B\u0E35\u0E16\u0E31\u0E14\u0E44\u0E1B",
    year: "\u0E1B\u0E35",
    today: "\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49",
    month: "\u0E40\u0E14\u0E37\u0E2D\u0E19",
    week: "\u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
    day: "\u0E27\u0E31\u0E19",
    list: "\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E01\u0E32\u0E23"
  },
  weekText: "\u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
  allDayText: "\u0E15\u0E25\u0E2D\u0E14\u0E27\u0E31\u0E19",
  moreLinkText: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
  noEventsText: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E34\u0E08\u0E01\u0E23\u0E23\u0E21\u0E17\u0E35\u0E48\u0E08\u0E30\u0E41\u0E2A\u0E14\u0E07"
};

exports.default = th;
